/* eslint-disable */
/**
 * Variables for Fonts and Colors used through out the app
 */

/**
 * Variables for determining which build we are on, builds are helios-nissan, helios-infiniti,
 * nna-nissan or nna-infiniti
 */
const nissan = process.env.BRAND_NAME === 'nissan';
const helios = process.env.VENDOR === 'helios';
const build = `${process.env.VENDOR}-${process.env.BRAND_NAME}`;

// Backup fonts
export const arial = 'arial, helvetica, verdana, sans-serif';
export const helvetica = 'Helvetica' + backup;
export const backup = arial;

// NNA fonts
// export const nissan_regular = `NissanBrand-Regular, ${backup}`;
export const nissan_regular = `nissan-ag, ${backup}`;
export const nissan_light = `nissan-ag, ${backup}`;
export const nissan_bold = `nissan-ag-n7, ${backup}`;

export const infiniti_thin = 'infiniti-thin';
export const infiniti_metapro_n4 = 'infiniti-metapro-n4';
export const infiniti_metapro = 'infiniti-metapro';
export const metapro_norm = 'MetaProNorm';
export const infiniti_regular = `${infiniti_thin}, ${infiniti_metapro_n4}, ${infiniti_metapro}, ${metapro_norm}, ${backup}`;

// Helios fonts
export const helios_nissan_light = `Nissan Light, ${backup}`;
export const helios_nissan_regular = `Nissan Regular, ${backup}`;
export const helios_nissan_bold = `Nissan Bold, ${backup}`;
export const helios_nissan_icon = 'icon-Nissan-Global';
export const helios_infiniti_light = `Infiniti Light, ${backup}`;
export const helios_infiniti_regular = `Infiniti Regular, ${backup}`;
export const helios_infiniti_bold = `Infiniti Bold, ${backup}`;
export const helios_infiniti_icon = 'icon-Infiniti-Global';


//Font Vars based on build
export let regular, light, bold, icon;

switch(build) {
  case 'nna-infiniti':
    regular = infiniti_regular;
    light = infiniti_regular;
    bold = infiniti_regular;
    icon = '';
    break;

  case 'helios-nissan':
    regular = helios_nissan_regular;
    light = helios_nissan_light;
    bold = helios_nissan_bold;
    icon = helios_nissan_icon;
    break;

  case 'helios-infiniti':
    regular = helios_infiniti_regular;
    light = helios_infiniti_light;
    bold = helios_infiniti_bold;
    icon = helios_infiniti_icon;
    break;

  default :
    regular = nissan_regular;
    light = nissan_light;
    bold = nissan_bold;
    icon = '';
}

/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./src/css/fonts.js
 **/